import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante } from '../../../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro de clientes internet */
export const acessosClienteInternet: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante];

@Injectable()
export class CanActivateClienteInternet implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosClienteInternet);
    }
}
